export default __webpack_public_path__ + "static/media/FUEL FARM TRUCK.3f8eadab.png";